// noinspection ES6UnusedImports

import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { getCurrentUser, fetchAuthSession, signInWithRedirect } from "aws-amplify/auth";
import App from "App";
import { QueryClient, QueryClientProvider } from "react-query";
import { OpenAPI } from "./gen/clients";
import reportWebVitals from "./reportWebVitals";
import initI18n from "./i18n";

const initThis = async () => {
  // Check if user is signed in.  If the user is not signed in, then immediately redirect to login page.
  let isUserAuthenticated = false;
  try {
    await getCurrentUser();
    isUserAuthenticated = true;
  } catch (_e) {
    await signInWithRedirect({ provider: { custom: import.meta.env.VITE_IDP_PROVIDER_NAME } });
  }
  if (!isUserAuthenticated) {
    return;
  }

  await initI18n();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: true,
        refetchOnWindowFocus: false
      }
    }
  });

  // Set API client token
  OpenAPI.TOKEN = async () => {
    const session = await fetchAuthSession();
    return session?.tokens?.idToken?.toString() || "";
  };

  OpenAPI.BASE = import.meta.env.VITE_API_URL_OVERRIDE || OpenAPI.BASE;

  OpenAPI.ENCODE_PATH = (path: string) => path;

  // eslint-disable-next-line
  // import i18n from './i18n';

  ReactDOM.render(
    <React.StrictMode>
      <Suspense fallback="...is loading">
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </Suspense>
    </React.StrictMode>,
    document.getElementById("root")
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
};
initThis();
